import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames/bind';

import Button from 'components/App/Button';

import images from 'assets/images';
import INITIAL_VALUE from 'constants/initialValue';

import styles from './ModalRequestAction.module.scss';

const cx = classNames.bind(styles);

function ModalRequestAction(props) {
  const {
    isOpen,

    icon: Icon,

    textRequest,

    onCloseModal,
    onConfirm,

    isLoadingConfirm = false,
    footerClassName,
  } = props;

  return (
    <Modal
      className={cx('ModalOverplay')}
      isOpen={isOpen}
      toggle={onCloseModal}
      contentClassName={cx('Modal')}
    >
      <ModalBody className={cx('ModalBody')}>
        <Button isDefault classes={cx('Button__Close')} onClick={onCloseModal}>
          <img src={images.modalClose.default} alt="" className="img-fluid img-close" />
        </Button>

        {(Icon && typeof Icon === 'string') ? <img src={Icon} alt="" className="img-fluid img-close" /> : <Icon />}

        <p>
          {textRequest}
        </p>
      </ModalBody>

      <ModalFooter className={`${cx('ModalFooter')} ${footerClassName}`}>
        <button type="button" className={cx('Button__Cancel')} onClick={onCloseModal}>Huỷ</button>
        <button
          type="button"
          className={cx('Button__Confirm')}
          onClick={onConfirm}
          disabled={isLoadingConfirm}
          loading={isLoadingConfirm}
        >
          {isLoadingConfirm ? 'Đang xử lý...' : 'Xác nhận'}
        </button>
      </ModalFooter>
    </Modal>
  );
}

ModalRequestAction.propTypes = {
  isOpen: PropTypes.bool.isRequired,

  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  textRequest: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  onCloseModal: PropTypes.func,
  onConfirm: PropTypes.func,

  isLoadingConfirm: PropTypes.bool,
  footerClassName: PropTypes.string,
};

ModalRequestAction.defaultProps = {
  icon: INITIAL_VALUE.STRING || INITIAL_VALUE.OBJECT,

  onCloseModal: INITIAL_VALUE.FUNCTION,
  onConfirm: INITIAL_VALUE.FUNCTION,
  isLoadingConfirm: false,
  footerClassName: '',
};

export default React.memo(ModalRequestAction);
